import styled from '@emotion/styled';
import mediaQuery from '@/lib/styling/mediaQuery';
import TonalIconButton from '@/components/TonalIconButton';

const TasksIconButton = styled(TonalIconButton)({
  marginLeft: 12,
  width: 48,
  height: 48,
  [mediaQuery(640)]: {
    width: 40,
    height: 40,
  },
});

export default TasksIconButton;
